"use client";

import './accordion.css';
import { __rest } from '../../_virtual/_tslib.js';
import { jsxs, jsx } from 'react/jsx-runtime';
import { useState, useRef, useId, Children, Fragment, cloneElement } from 'react';
import { useViewport, Text, Accordion as Accordion$1 } from '@vds/core';
import AccordionItem from './accordion-item.js';
import styles from './accordion.module.scss.js';

const Accordion = (props) => {
    const { id, size = 'large', items, padding, fullBleed = false, surface = 'lightPrimary', topLine, title, bottomLine = false, triggerAlignment, triggerElement, behavior, viewport: viewportProp, inset, contentWidth, children } = props, rest = __rest(props, ["id", "size", "items", "padding", "fullBleed", "surface", "topLine", "title", "bottomLine", "triggerAlignment", "triggerElement", "behavior", "viewport", "inset", "contentWidth", "children"]);
    const viewport = useViewport('standard', viewportProp);
    const isSingleOpen = behavior === 'singleOpen';
    const initialOpenedItemIndex = isSingleOpen && (items === null || items === void 0 ? void 0 : items.findIndex((item) => item.opened));
    const surfaceColor = surface === null || surface === void 0 ? void 0 : surface.toLowerCase();
    const accordionItemStyles = [styles.accordionItem];
    const accordionWrapperStyles = [styles.accordionWrapper];
    const titleWrapperStyles = [styles.titleWrapper];
    const [activeAccordionID, setactiveAccordionID] = useState(undefined);
    const idPrefix = useRef(null);
    const _useId = useId();
    if (idPrefix.current === null)
        idPrefix.current = id || _useId;
    if (padding === 'compact') {
        titleWrapperStyles.push(styles.compact);
    }
    if (fullBleed) {
        accordionWrapperStyles.push(styles.fullBleed);
        titleWrapperStyles.push(styles.fullBleed);
    }
    if (!topLine)
        titleWrapperStyles.push(styles.noPadding);
    const geTitleSize = () => {
        switch (size) {
            case 'small':
                return 'medium';
            case 'medium':
                return 'large';
            case 'large':
            default:
                return viewport === 'mobile' ? '2xsmall' : 'xsmall';
        }
    };
    return (jsxs("div", { className: accordionWrapperStyles.join(' '), children: [title && (jsx("div", { className: titleWrapperStyles.join(' '), style: {
                    '--inset-value': inset,
                }, children: jsx(Text, Object.assign({ kind: size === 'large' ? 'title' : 'body', size: geTitleSize(), bold: true, color: `var(--vds-color-element-primary-on${surfaceColor})` }, title)) })), jsx(Accordion$1, Object.assign({ viewport: viewport, triggerElement: triggerElement, triggerAlignment: triggerAlignment }, rest, { topLine: false, children: items
                    ? items === null || items === void 0 ? void 0 : items.map((item, index) => {
                        const accordionItemId = `${idPrefix.current}_${index}`;
                        const isActive = activeAccordionID === accordionItemId;
                        const { opened } = item, restOfItem = __rest(item, ["opened"]);
                        const isOpened = isSingleOpen && index !== initialOpenedItemIndex
                            ? false
                            : opened;
                        return (jsx("div", { className: accordionItemStyles.join(' '), children: jsx(AccordionItem, Object.assign({ topLine: topLine && index === 0, padding: padding, size: size, surface: surface, viewport: viewport, bottomLine: bottomLine ? true : index !== items.length - 1, activeAccordionID: activeAccordionID, accordionItemId: `${idPrefix.current}_${index}`, triggerElement: triggerElement, triggerAlignment: triggerAlignment, behavior: behavior, inset: inset, fullBleed: fullBleed, contentWidth: contentWidth, onClick: () => {
                                    setactiveAccordionID(isActive ? undefined : accordionItemId);
                                }, opened: isOpened }, restOfItem)) }, index));
                    })
                    : Children.map(children, (c, index) => {
                        const child = c;
                        /* istanbul ignore else */
                        if (!child || typeof child === 'boolean')
                            return null;
                        const CHILDREN_COUNT = Children.toArray(children).length;
                        let childElement = child.type === Fragment ? child.props.children : child;
                        childElement =
                            childElement instanceof Array ? childElement[0] : childElement;
                        const childType = childElement.type && childElement.type.componentType
                            ? childElement.type.componentType
                            : '';
                        const accordionItemId = `${idPrefix.current}_${index}`;
                        const isActive = activeAccordionID === accordionItemId;
                        if (childType === 'AccordionItem') {
                            return cloneElement(childElement, {
                                topLine: topLine && index === 0,
                                bottomLine: index === CHILDREN_COUNT - 1 ? bottomLine : true,
                                fullBleed,
                                contentWidth,
                                activeAccordionID,
                                accordionItemId,
                                padding,
                                inset,
                                behavior,
                                viewport,
                                surface,
                                size,
                                onClick: () => {
                                    setactiveAccordionID(isActive ? undefined : accordionItemId);
                                },
                            });
                        }
                        return child;
                    }) }))] }));
};

export { Accordion as default };
